import React, { useState, useContext, } from 'react';
import axios from 'axios';
import {
  CircularProgress,
} from '@material-ui/core';
import LinkIcon from '@material-ui/icons/Link';
import Videocam from '@material-ui/icons/Videocam';
import PropTypes from 'prop-types';
import { storeContext } from '../provider/Provider';
import useStyles from './SearchIntelligence.style';
import theme from '../../theme';

const { REACT_APP_SEARCH_INTELLIGENCE_API_KEY } = process.env;

const MobileSearchIntelligence = ({row}) => {
  const [fullView, setFullview] = useState(false);
  const classes = useStyles();
  const { state } = useContext(storeContext);
  const [isFetching, setIsFetching] = useState(false);
  const [placements, setPlacements] = useState([]);


  const handleClick = () => {
    if(!fullView){
      setIsFetching(true);
      axios
      .get(
          `https://admin.search-intelligence.co.uk/wp-json/si-rest-api/v1/client/placements?domain=${state.websiteSwitch.currentWebsite}&campaign_name=${row.campaign_name}`,
          {
            headers:{'x-api-key': REACT_APP_SEARCH_INTELLIGENCE_API_KEY,},
          }
      )
      .then((res) => {
          setIsFetching(false);  
          setPlacements(res.data);
      })
      .catch(() => {
        setIsFetching(false);
      });
    }
    setFullview(!fullView);
  };

  const capitalization = (str) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

  return (
      <>
      <div
          className={classes.mobileCard}
          key={row.campaign_name}
          onClick={handleClick}
          role="presentation"
          aria-label="default box"
      >
          {fullView? 
          (<>
              <div style={{ display: "flex", flexDirection: 'column'}}>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Campaign Name</div>
                  <div className={classes.columnValue}>{row.campaign_name}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Date</div>
                  <div className={classes.columnValue}>{`${new Date(row.first_link_date).toLocaleString('en-US', {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                  })}`}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>DR &ge; 70</div>
                  <div className={classes.columnValue}>{row.ht_count_links}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Link Count</div>
                  <div className={classes.columnValue}>{row.count_links}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Status</div>
                  <div className={classes.columnValue}>{row.status}</div>
                </div>
                <div className={classes.flexLine}>
                  <div className={classes.columnTitle}>Media</div>
                  <div className={classes.columnValue}>{row.video? (<Videocam style={{ color: theme.palette.primary.dark, fontSize: 20 }} />): "-"}</div>
                </div>
              </div>
              <div
              style={{ background: '#00B4E0', height: '1px', width: '100%', margin: '10px 0' }}
              />
              {isFetching ? <CircularProgress /> :
              placements.map((placement) => (
                  <React.Fragment key={placement.link}>
                    <div style={{ display: "flex", gap: '10px', color: '#00B5E2', borderBottom: '1px solid lightGrey', padding:'9px 5px 1px'}}>
                      <LinkIcon style={{ width: "14px"}} />
                      <a 
                        href={placement.link} 
                        style={{ 
                          textDecoration: 'none', 
                          color: '#00B5E2',
                          maxWidth: '70vw',
                        }} 
                        target="_blank"
                        rel="noreferrer">
                        <div className={classes.linkEllipsis} style={{maxWidth:'100vw'}}>
                          {placement.link}
                        </div>
                      </a>
                    </div>
                  </React.Fragment>
                  )
              )}
          </>):
          (<div className={classes.flexLineDefault}>
              <div style={{ width: '20%', userSelect: 'none' }}>{`${new Date(row.first_link_date).toLocaleString('en-US', {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
              })}`}</div>
              <div style={{ width: '80%', userSelect: 'none' }}>{capitalization(row.campaign_name)}</div>
          </div>)}
      </div>  
  </>
  );
}

MobileSearchIntelligence.propTypes = {
  row: PropTypes.shape({
    campaign_name: PropTypes.string,
    first_link_date: PropTypes.string,
    ht_count_links: PropTypes.number,
    count_links: PropTypes.number,
    status: PropTypes.string,
    video: PropTypes.bool,
  }),
};

MobileSearchIntelligence.defaultProps = {
  row: {},
};

export default MobileSearchIntelligence;
